import React from 'react';
import { AlertCircle, MessageSquare, X } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * SendQuotePrompt - Shown when user arrives at Inbox via Calculator handoff
 * but no conversation exists for the lead.
 */
const SendQuotePrompt = ({ 
  quoteId, 
  leadId, 
  noConversation,
  onDismiss,
  onStartConversation,
}) => {
  if (!noConversation) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white/95 z-10">
      <div className="max-w-sm mx-4 p-6 bg-white border border-gray-200 rounded-xl shadow-lg text-center">
        <div className="h-12 w-12 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center">
          <AlertCircle className="h-6 w-6 text-amber-600" />
        </div>
        
        <h3 className="text-base font-semibold text-gray-900 mb-2">
          No conversation yet
        </h3>
        
        <p className="text-sm text-gray-600 mb-6">
          Start a conversation with this lead first, then you can send the quote via SMS.
        </p>

        <div className="flex flex-col gap-2">
          <Button onClick={onStartConversation} className="w-full">
            <MessageSquare className="h-4 w-4 mr-2" />
            Start Conversation
          </Button>
          <Button variant="outline" onClick={onDismiss} className="w-full">
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SendQuotePrompt;
